import React, { Fragment ,useState} from 'react'
import {AppTable,AppRow,AppButton,AppGridLayout,
    AppTableSearch,SearchEnum,AppSearchItem,AppFilter} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row, Icon,Tag ,Button} from 'antd';

const tableData =[
    {id:1,parentId:0,name:"一级菜单A",rank:1,code:'ppp'},
    {id:2,parentId:0,name:"一级菜单B",rank:1,code:'ppp'},
    {id:3,parentId:0,name:"一级菜单C",rank:1,code:'ppp'},
    {id:4,parentId:1,name:"二级菜单A-A",rank:2,code:'ppp'},
    {id:5,parentId:1,name:"二级菜单A-B",rank:2,code:'ppp'},
    {id:6,parentId:2,name:"二级菜单B-A",rank:2,code:'ppp'},
    {id:7,parentId:4,name:"三级菜单A-A-A",rank:3,code:'ppp'},
    {id:8,parentId:7,name:"四级菜单A-A-A-A",rank:4,code:'ppp'},
    {id:9,parentId:8,name:"五级菜单A-A-A-A-A",rank:5,code:'ppp'},
    {id:10,parentId:9,name:"六级菜单A-A-A-A-A-A",rank:6,code:'ppp'},
    {id:11,parentId:10,name:"七级菜单A-A-A-A-A-A-A",rank:7,code:'ppp'},
    {id:12,parentId:11,name:"八级菜单A-A-A-A-A-A-A-A",rank:8,code:'ppp'},
    {id:13,parentId:12,name:"九级菜单A-A-A-A-A-A-A-A-A",rank:9,code:'ppp'},
    {id:14,parentId:13,name:"十级菜单A-A-A-A-A-A-A-A-A-A",rank:10,code:'ppp'}
]


const options = [
    {label:'111',value:'222'},
    {label:'111',value:'33'},
    {label:'111',value:'44'},
    {label:'111',value:'55'},
    {label:'111',value:'66'},
    {label:'111',value:'77'},
    {label:'111',value:'88'},
    {label:'111',value:'99'},
    {label:'111',value:'00'},
    {label:'111',value:'09'},
    {label:'111',value:'77'},
    {label:'111',value:'uu'},
    {label:'111',value:'ii'},
    {label:'111',value:'oo'},
    {label:'111',value:'pp'},
    {label:'111',value:'222'},
    {label:'111',value:'kk'},
    {label:'111',value:'kk'},
    {label:'111',value:'gg'},
    {label:'111',value:'hh'},
    {label:'111',value:'hyy'},
    {label:'111',value:'ff'},
    {label:'111',value:'vv'},
    {label:'111',value:'bb'},
    {label:'111',value:'nn'},
    {label:'111',value:'mm'},
    {label:'111',value:'ll'},
    {label:'111',value:'aa'},
    {label:'111',value:'dd'},
    {label:'111',value:'ee'},
]

export const AppGridLayoutDemo = () =>{

    const onSearch = (filterList?:AppFilter[],data?:any) =>{
        console.log('AppGridLayoutDemo_filterList:',filterList)
        console.log('AppGridLayoutDemo_data:',data)
    }

    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、此为组合布局。<br/>
                2、使用AppGridLayoutProvider来串联各个组件的联动。<br/>
                3、引用：import {`{AppGridLayout}`} from 'qcc'<br/>
                4、demo位置：src/demo/components/AppGridLayoutDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo' style={{height:400}}>
                <AppGridLayout>
                    <AppGridLayout.SearchArea>
                        <AppTableSearch 
                        // onSearch={onSearch}
                        >
                            <AppTableSearch.Common>
                                <AppSearchItem.ProjectTree keyName='organId' field='a.organid' lable='项目'/>
                                <AppSearchItem.SearchInput placeholder='请录入姓名' keyName='common' field='a.b|a.c'/>
                            </AppTableSearch.Common>
                            <AppTableSearch.Advanced>
                                <AppSearchItem.Advanced keyName='text' field='text' lable='文本:'/>
                                <AppSearchItem.Advanced keyName='multCheck' field='multCheck' itemType={SearchEnum.itemType.multCheck} options={options} lable='多选:'/>
                                <AppSearchItem.Advanced keyName='numberRange' field='numberRange' itemType={SearchEnum.itemType.numberRange} lable='数字区间:'/>
                                <AppSearchItem.Advanced keyName='dateRange' field='dateRange' itemType={SearchEnum.itemType.dateRange} lable='日期区间:'/>
                            </AppTableSearch.Advanced>
                        </AppTableSearch>
                    </AppGridLayout.SearchArea>
                    <AppGridLayout.GridArea>
                        <AppTable dataSource={tableData} >
                            <AppTable.ColIndex />
                            <AppTable.ColCheckbox/>
                            <AppTable.Col title='名称' field='name'  expand/>
                            <AppTable.ColInt title='整数hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh' width={100} field='rank' />
                            <AppTable.ColMoney title='金额' field='rank' width={100} />
                            <AppTable.ColAction render={(data:any,dataIndex:number)=>{
                                return (<AppRow itemSplit={10} style={{float:'right'}}>
                                    <AppButton type='link' label='编辑' />
                                    <AppButton type='link' label='删除' />
                                    <AppButton type='link' label='更多操作' >
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                    </AppButton>
                                </AppRow>)
                            }}/>
                        </AppTable>
                    </AppGridLayout.GridArea>
                    
                </AppGridLayout>
            </div>
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppGridLayoutDemo.tsx